import React from 'react'
import PropTypes from 'prop-types'
import Prompt from './Prompt'

const Eula = ({ open }) => {
    if (!open) return null

    return <Prompt />
}

Eula.propTypes = {
    open: PropTypes.bool.isRequired,
}

export default Eula



// WEBPACK FOOTER //
// ./src/features/Eula/components/Eula/component.js